<div class="port-container">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-selected-comm-port-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status:
                        port.used === 0 || (port.timeout === 1 && isReceivingData),
                    disconnected_status: !isReceivingData,
                    stable_status:
                        port.used !== 0 && port.timeout !== 1 && isReceivingData,
                }"
            />
            {{ "system-status.comms.port" | translate }}
            {{ " " + (index + 1) }}
        </div>
    </div>
</div>
